<ng-container *transloco="let t; scope: 'core'">
  <ng-container *ngIf="{ isLoggedIn: isLoggedIn$ | async, activeFavoriteList: activeFavoriteList$ | async } as context">
    <ng-container *ngIf="activeFavoriteItems$ | async as items">
      <div
        class="header-dropdown"
        id="header-dropdown-favourite"
        tabindex="0"
        [class.active]="status"
        [class.inactive]="inactive"
        (mouseleave)="resetInactive()"
      >
        <!-- icon with count badge -->
        <div class="header-dropdown-label" (click)="toggleDropdown()">
          <div class="icon-wrapper">
            <i class="icon-heart-filled"></i>
            <span class="badge" [ngClass]="{ 'badge--xl': items.length > 9 }">{{ items.length }}</span>
          </div>
        </div>

        <div class="header-dropdown-content">
          <div class="header-dropdown-content-mobile-header flex mini-cart-item-justify">
            <div>
              <i class="header-dropdown-content-mobile-header-icon icon-heart-filled"></i> {{ t("core.header-nav.favorite-menu.favlist") }}
            </div>
            <div (click)="closeDropdown()"><i class="icon-close"></i></div>
          </div>

          <div class="mini-cart">
            <div [hidden]="context.isLoggedIn === false" class="mini-cart-item mini-cart-select default-font-sizes linked">
              <mat-form-field>
                <select (ngModelChange)="setActiveFavoriteList($event)" [ngModel]="context.activeFavoriteList" matNativeControl>
                  <option disabled>{{ t("core.header-nav.favorite-menu.choose-favlist") }}</option>
                  <option *ngFor="let list of favoriteLists$ | async" [ngValue]="list" class="optionClass">
                    {{ t("core.header-nav.favorite-menu.favlist") }}: {{ list.sListname }}
                  </option>
                </select>
              </mat-form-field>
            </div>

            <div *ngIf="isLoggedIn$ | async; else loggedOut">
              <div *ngIf="items.length < 1" class="mini-cart">
                <div class="mini-cart-item default-font-sizes empty-cart-item">
                  {{ t("core.header-nav.favorite-menu.add-to-favlist-message") }}
                </div>
              </div>
            </div>
            <ng-template #loggedOut>
              <div *ngIf="items.length < 1" class="mini-cart">
                <div class="mini-cart-item default-font-sizes">
                  {{ t("core.header-nav.favorite-menu.add-or-login-message") }}
                </div>
              </div>
            </ng-template>

            <div *ngIf="isLoggedIn$ | async" class="mini-cart-item default-font-sizes linked">
              <a [routerLink]="'/profile/favorites' | localizeUrlPath" class="mini-cart-item-justify" (click)="closeDropdown()">
                <span> {{ t("core.header-nav.favorite-menu.manage-favlist") }}</span>

                <i class="icon-setting"></i>
              </a>
            </div>

            <div *ngIf="isLoggedIn$ | async" class="mini-cart-item default-font-sizes linked">
              <a [routerLink]="'/profile/favorites/new/' | localizeUrlPath" class="mini-cart-item-justify" (click)="closeDropdown()">
                <span> {{ t("core.header-nav.favorite-menu.add-favlist") }} </span>

                <i class="icon-plus"></i>
              </a>
            </div>

            <ng-container *ngIf="generatedLists$ | async as generatedLists">
              <div *ngFor="let list of generatedLists" class="mini-cart-item default-font-sizes linked">
                <a
                  [routerLink]="'/profile/favorites/' + list.gListID + '/items' | localizeUrlPath"
                  class="mini-cart-item-justify"
                  (click)="closeDropdown()"
                >
                  <span>{{ list.sListname }}</span>
                  <i class="icon-goto"></i>
                </a>
              </div>
            </ng-container>

            <div *ngFor="let item of items" class="mini-cart-item">
              <app-favorite-item [favoriteItem]="item"></app-favorite-item>
            </div>

            <div class="mini-cart-item mini-cart-footer" *ngIf="context.activeFavoriteList as list">
              <a
                [routerLink]="'/profile/favorites/' + list.gListID + '/items' | localizeUrlPath"
                class="btn btn--wide text-centered default-font-sizes"
                (click)="closeDropdown()"
              >
                <i class="icon-heart"></i> {{ t("core.header-nav.favorite-menu.to-favlist") }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <!-- label for icon - below  -->
    <div class="header-nav-item-text">
      <ng-template #notLoggedin>
        <div>{{ t("core.header-nav.favorite-menu.favlist") }}</div>
      </ng-template>

      <div *ngIf="context.isLoggedIn; else notLoggedin">
        <i class="icon-arrow header-nav-item-text-icon header-nav-item-text-icon--first"></i>
        <div
          *ngIf="context.activeFavoriteList"
          [matTooltipClass]="'tooltip-main'"
          [matTooltipPosition]="'below'"
          [matTooltip]="context.activeFavoriteList.sListname"
          class="listname-header-nav"
        >
          {{ context.activeFavoriteList.sListname }}
        </div>
        <i class="icon-arrow header-nav-item-text-icon header-nav-item-text-icon--last"></i>
      </div>
    </div>
  </ng-container>
</ng-container>
